module.exports = __webpack_public_path__ + "cgd-icon.65ce77350f4a205805cd.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/corporate/css/fonts/cgd-icon.eot
// module id = ../../../../../src/assets/corporate/css/fonts/cgd-icon.eot
// module chunks = styles